import { createApi } from "@reduxjs/toolkit/query/react";

import type {
  IAddEncashmentRequest,
  IUpdateEncashmentRequest,
  TAddEncashmentResponse,
  TGetEncashmentByIdRequest,
  TGetEncashmentByIdResponse,
  TGetEncashmentsListingRequest,
  TGetEncashmentsListingResponse,
  TUpdateEncashmentResponse,
} from "@/types/(company)/encashmentPolicy.interface";
import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";

export const companyEnchashmentPolicyApi = createApi({
  reducerPath: "companyEnchashmentPolicyApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["LeaveEncashments"],
  endpoints: (builder) => ({
    getAllEncashments: builder.query<
      TGetEncashmentsListingResponse,
      TGetEncashmentsListingRequest
    >({
      query: () => ({
        url: "/company/settings/encashment-policies",
        method: "GET",
      }),
      providesTags: ["LeaveEncashments"],
    }),
    addEncashment: builder.mutation<
      TAddEncashmentResponse,
      IAddEncashmentRequest
    >({
      query: (data) => ({
        url: "/company/settings/encashment-policies",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["LeaveEncashments"],
    }),
    getEncashmentById: builder.query<
      TGetEncashmentByIdResponse,
      TGetEncashmentByIdRequest
    >({
      query: ({ id }) => ({
        url: "/company/settings/encashment-policies" + `/${id}`,
        method: "GET",
      }),
      providesTags: ["LeaveEncashments"],
    }),
    updateEncashment: builder.mutation<
      TUpdateEncashmentResponse,
      IUpdateEncashmentRequest
    >({
      query: (data) => ({
        url: "/company/settings/encashment-policies/" + data.id,
        method: "PATCH",
        body: data.data,
      }),
      invalidatesTags: ["LeaveEncashments"],
    }),
    // 204 No Content: resolves with no body.
    deleteEncashment: builder.mutation<void, number>({
      query: (id) => ({
        url: "/company/settings/encashment-policies" + `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["LeaveEncashments"],
    }),
  }),
});

export const {
  useGetAllEncashmentsQuery,
  useAddEncashmentMutation,
  useGetEncashmentByIdQuery,
  useUpdateEncashmentMutation,
  useDeleteEncashmentMutation,
} = companyEnchashmentPolicyApi;
